import { CARRIER_COMPLIANCE_STATUSES } from 'constants/carriers'

const { inReview, needsReview, offer } = CARRIER_COMPLIANCE_STATUSES

const getNonOfferStatus = review => (review.complianceRep ? inReview : needsReview)

export const setComplianceStatus = shipment => ({
  ...shipment,
  coveredBid: {
    ...shipment.coveredBid,
    complianceStatus:
      shipment.coveredBid.complianceReview.status === 'approved'
        ? offer
        : getNonOfferStatus(shipment.coveredBid.complianceReview),
  },
})
